<template>
    <div class="container bg-secondary bg-gradient p-5">
            <h2>This is the contact page</h2>
    <p class="badge bg-dark text-white">{{ $store.getters.getName }}</p>

    </div>
</template>

<script>
    export default{

    }
</script>